import { SpacesAttributesResponseApi } from "./get-spaces-attributes.types";
import { apiLegacy } from "@/services/api-legacy";

export const GetSpacesAttributtesApi = async (spaceId: number) => {
  const { data } = await apiLegacy.get<SpacesAttributesResponseApi>(
    `/v0/spaces/${spaceId}/attributes`,
  );

  return data?._embedded?.spaceattributes;
};
